import PropTypes from 'prop-types'

/*
 * Angeschnittene Ausschnitte der echten Oberflächen, abstrakt nachgebaut.
 * Jeder Ausschnitt reagiert auf `--p` seiner Zeile (0 bis 1, während die
 * Zeile die Bildmitte passiert), so passiert die Aktion beim Scrollen.
 */

const Ic = ({ d, size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='1.9'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
  >
    <path d={d} />
  </svg>
)

Ic.propTypes = { d: PropTypes.string.isRequired, size: PropTypes.number }

const D = {
  plus: 'M12 5v14M5 12h14',
  check: 'M5 12.5l4.5 4.5L19 7.5',
  link: 'M9 15l6-6M10.5 6.5l1.2-1.2a4 4 0 0 1 5.7 5.7l-1.2 1.2M13.5 17.5l-1.2 1.2a4 4 0 0 1-5.7-5.7l1.2-1.2',
  copy: 'M9 9h10v10H9zM5 15V5h10',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7.5V12l3 2',
  users:
    'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 20a6 6 0 0 1 12 0M16 4.5a3.5 3.5 0 0 1 0 6.5M18 14a5.5 5.5 0 0 1 3 6',
  doc: 'M5 4h14v16H5zM8.5 8.5h7M8.5 12h7M8.5 15.5h4',
  arrow: 'M5 12h14M13 6l6 6-6 6',
  down: 'M6 9l6 6 6-6',
  bookmark: 'M7 4h10v16l-5-4-5 4z',
  x: 'M6 6l12 12M18 6L6 18'
}

const Av = ({ n, tone = 'light' }) => (
  <span className={`ln-av ln-av--${tone}`}>{n}</span>
)

Av.propTypes = { n: PropTypes.string.isRequired, tone: PropTypes.string }

/** Dashboard-Fenster mit schmaler dunkler Seitenleiste. */
function Shell({ title, children, action }) {
  return (
    <div className='ln-shell'>
      <span className='ln-shell__side'>
        <i className='ln-shell__logo' />
        <i />
        <i />
        <i />
      </span>
      <div className='ln-shell__main'>
        <div className='ln-shell__head'>
          <span className='ln-ui-h1'>{title}</span>
          {action}
        </div>
        {children}
      </div>
    </div>
  )
}

Shell.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  action: PropTypes.node
}

const Section = ({ title, sub, children }) => (
  <div className='ln-sec'>
    <span className='ln-sec__t'>{title}</span>
    {sub && <span className='ln-sec__s'>{sub}</span>}
    <span className='ln-sec__rule' />
    {children}
  </div>
)

Section.propTypes = {
  title: PropTypes.string.isRequired,
  sub: PropTypes.string,
  children: PropTypes.node
}

function Message() {
  return (
    <div className='ln-chat'>
      <div className='ln-chat__row'>
        <Av n='TK' />
        <div>
          <span className='ln-ui-b'>Tim K.</span>
          <span className='ln-ui-m'> · 09:12</span>
          <div className='ln-bubble'>
            Hi Sara, wir brauchen ab Q1 eine:n Account Manager:in. Kannst du die
            Stelle anlegen?
          </div>
        </div>
      </div>
      <div
        className='ln-chat__row ln-chat__row--me ln-reveal'
        style={{ '--at': 0.55 }}
      >
        <div className='ln-bubble ln-bubble--me'>Mach ich direkt in Aivy.</div>
      </div>
    </div>
  )
}

function NewJob() {
  return (
    <Shell
      title='Stellen'
      action={
        <span className='ln-btn ln-press' style={{ '--at': 0.1 }}>
          <Ic d={D.plus} /> Neue Stelle anlegen
        </span>
      }
    >
      <div className='ln-modal ln-reveal' style={{ '--at': 0.14 }}>
        <span className='ln-ui-b'>Neue Stelle</span>
        <span className='ln-label'>Name der Stelle</span>
        <span className='ln-input'>
          <span className='ln-type'>Account Manager Vertrieb</span>
          <i className='ln-caret' />
        </span>
        <span className='ln-label'>Standort</span>
        <span className='ln-input ln-input--muted'>Hamburg</span>
      </div>
    </Shell>
  )
}

function Choice() {
  return (
    <Shell title='Anforderungsprofil erstellen'>
      <div className='ln-opts'>
        <span className='ln-opt ln-opt--pick'>
          <span className='ln-opt__ic'>
            <Ic d={D.doc} size={16} />
          </span>
          <span className='ln-badge ln-badge--blue'>Vorlage von Aivy</span>
          <span className='ln-ui-b'>Aivy-Vorlage verwenden</span>
          <span className='ln-ui-m'>Sofort startklar</span>
        </span>
        <span className='ln-opt'>
          <span className='ln-opt__ic'>
            <Ic d={D.users} size={16} />
          </span>
          <span className='ln-badge ln-badge--grey'>Optional</span>
          <span className='ln-ui-b'>Kolleg:innen befragen</span>
          <span className='ln-ui-m'>5 bis 10 Min. pro Person</span>
        </span>
      </div>
    </Shell>
  )
}

const EXPERT = [
  ['TK', 74, 'ink'],
  ['JW', 56, 'light'],
  ['AD', 90, 'light']
]

function Expert() {
  return (
    <div className='ln-quest'>
      <span className='ln-ui-m'>Frage 3 von 12 · Expertenanalyse</span>
      <span className='ln-ui-q'>
        Wie wichtig ist Kommunikation für die Stelle?
      </span>
      <div className='ln-scale'>
        <span className='ln-scale__track' />
        {EXPERT.map(([n, v, tone], i) => (
          <span key={n} className='ln-scale__mk' style={{ '--v': v, '--i': i }}>
            <Av n={n} tone={tone} />
          </span>
        ))}
        <span className='ln-scale__ends'>
          <span>unwichtig</span>
          <span>sehr wichtig</span>
        </span>
      </div>
    </div>
  )
}

const DIMS = [
  ['Problemlösefähigkeit', 70, 90],
  ['Kommunikation', 66, 88],
  ['Sorgfalt', 55, 75],
  ['Belastbarkeit', 50, 70]
]

function Bars({ person }) {
  return (
    <div className='ln-bars'>
      {DIMS.map(([label, lo, hi], i) => (
        <div key={label} className='ln-bars__row' style={{ '--i': i }}>
          <span className='ln-cap'>{label}</span>
          <span className='ln-bars__track'>
            <i
              className='ln-bars__transit'
              style={{
                '--lo': Math.max(0, lo - 10),
                '--hi': Math.min(100, hi + 10)
              }}
            />
            <i className='ln-bars__ideal' style={{ '--lo': lo, '--hi': hi }} />
            {person && (
              <i className='ln-bars__mk' style={{ '--v': person[i] }} />
            )}
          </span>
        </div>
      ))}
    </div>
  )
}

Bars.propTypes = { person: PropTypes.arrayOf(PropTypes.number) }

function Profile() {
  return (
    <Shell
      title='Anforderungsprofil'
      action={<span className='ln-badge ln-badge--blue'>Vorlage von Aivy</span>}
    >
      <Bars />
    </Shell>
  )
}

function Invite() {
  return (
    <div className='ln-modal ln-modal--flat'>
      <span className='ln-ui-b'>Talent einladen</span>
      <span className='ln-tabs'>
        <span className='is-on'>Per Link einladen</span>
        <span>Per E-Mail einladen</span>
      </span>
      <span className='ln-input'>
        <Ic d={D.link} />
        <span className='ln-mono'>app.aivy.app/?invitation=7f3a9c2e</span>
        <span className='ln-copy'>
          <Ic d={D.copy} />
        </span>
      </span>
      <span className='ln-auto ln-reveal' style={{ '--at': 0.45 }}>
        <span className='ln-dot' />
        Automatisch beim Statuswechsel in eurem ATS
      </span>
    </div>
  )
}

function Challenge() {
  return (
    <div className='ln-phone'>
      <div className='ln-game'>
        <span className='ln-game__top'>
          <Ic d={D.clock} /> <span className='ln-count'>00:05</span>
          <b>Übungsrunde</b>
        </span>
        <span className='ln-game__q'>
          Welche Aussage passt am meisten zu dir?
        </span>
      </div>
      <div className='ln-game__opts'>
        <span className='ln-pick ln-pick--no'>
          <i>
            <Ic d={D.x} />
          </i>
          … eine starke Position einnehmen.
        </span>
        <span className='ln-pick'>… mich für andere einsetzen.</span>
        <span className='ln-pick ln-pick--yes'>
          … meine Arbeit mit Freude angehen.
          <i>
            <Ic d={D.check} />
          </i>
        </span>
      </div>
    </div>
  )
}

function Strength() {
  return (
    <div className='ln-phone ln-phone--plain'>
      <span className='ln-ui-m'>Geschafft, Lena!</span>
      <span className='ln-ui-q'>Dein Stärkenprofil ist fertig.</span>
      <div className='ln-dl'>
        <span className='ln-dl__art'>
          <i />
          <i />
          <i />
        </span>
        <span className='ln-dl__t'>Stärkenprofil</span>
        <span className='ln-dl__b'>Download</span>
      </div>
    </div>
  )
}

const ROWS = [
  ['Lena M.', 82, 'high'],
  ['Jonas P.', 78, 'high'],
  ['Mia K.', 74, 'mid'],
  ['Can Y.', 61, 'mid']
]

function Table() {
  return (
    <Shell
      title='Talente'
      action={
        <span className='ln-btn'>
          <Ic d={D.plus} /> Talent einladen
        </span>
      }
    >
      <div className='ln-table'>
        <span className='ln-table__head'>
          <span>Kennung</span>
          <span>Fortschritt</span>
          <span>Score</span>
        </span>
        {ROWS.map(([n, s, fit], i) => (
          <span key={n} className='ln-table__row' style={{ '--i': i }}>
            <span className='ln-ui-b'>{n}</span>
            <span className='ln-ring'>100</span>
            <span className={`ln-sc ln-sc--${fit}`}>{s}</span>
          </span>
        ))}
      </div>
    </Shell>
  )
}

function Insights() {
  return (
    <Section title='Key Insights' sub='Lena M. · Account Manager Vertrieb'>
      <div className='ln-ins'>
        <span className='ln-cap ln-cap--blue'>Passung</span>
        <span className='ln-ins__l ln-reveal' style={{ '--at': 0.2 }}>
          <Ic d={D.arrow} /> Sehr hohe Problemlösefähigkeit, passt zur Stelle
        </span>
        <span className='ln-cap ln-cap--blue'>Im Interview vertiefen</span>
        <span className='ln-ins__l ln-reveal' style={{ '--at': 0.4 }}>
          <Ic d={D.arrow} /> Belastbarkeit liegt knapp unter dem Idealbereich
        </span>
        <span className='ln-ins__l ln-reveal' style={{ '--at': 0.55 }}>
          <Ic d={D.arrow} /> Frag nach Situationen mit hohem Zeitdruck
        </span>
      </div>
    </Section>
  )
}

function Hire() {
  return (
    <Section
      title='Assessmentinformationen'
      sub='Lena M. · Account Manager Vertrieb'
    >
      <div className='ln-info'>
        <span className='ln-cap'>Talent-Status</span>
        <span className='ln-cap'>Passung zur Stelle</span>
        <span className='ln-status'>
          <span className='ln-btn ln-btn--sm ln-status__before'>
            <Ic d={D.bookmark} size={12} /> Status hinterlegen
          </span>
          <span className='ln-badge ln-badge--green ln-status__after'>
            Eingestellt
          </span>
        </span>
        <span className='ln-pass'>82</span>
      </div>
      <div className='ln-menu ln-menu--hire'>
        <span>Offen</span>
        <span>Qualifiziert</span>
        <span className='is-on'>
          Eingestellt <Ic d={D.check} size={12} />
        </span>
        <span>Abgelehnt</span>
      </div>
    </Section>
  )
}

function Learn() {
  return (
    <Section
      title='Anforderungsprofil'
      sub='Lernt aus euren Einstellungen · SmartPredict'
    >
      <span className='ln-badge ln-badge--green ln-learn__tag'>
        Probezeit überstanden
      </span>
      <Bars person={[86, 80, 66, 62]} />
    </Section>
  )
}

// Fünf Achsen, Team und neue Kollegin
const AX = 5
const pt = (i, v, r = 70) => {
  const a = -Math.PI / 2 + (i * 2 * Math.PI) / AX
  return [90 + Math.cos(a) * r * (v / 100), 90 + Math.sin(a) * r * (v / 100)]
}
const poly = (vals) => vals.map((v, i) => pt(i, v).join(',')).join(' ')

function Radar() {
  return (
    <Section title='Teamanalyse' sub='Team Vertrieb · 8 Mitarbeitende'>
      <svg className='ln-radar' viewBox='0 0 180 180' aria-hidden='true'>
        {[100, 66, 33].map((r) => (
          <polygon
            key={r}
            points={poly(Array(AX).fill(r))}
            fill='none'
            stroke='#E5E7EB'
          />
        ))}
        <polygon
          className='ln-radar__team'
          points={poly([72, 58, 80, 64, 50])}
        />
        <polygon
          className='ln-radar__new ln-reveal'
          style={{ '--at': 0.22 }}
          points={poly([86, 80, 66, 62, 74])}
        />
      </svg>
      <span className='ln-legend'>
        <span>
          <i className='ln-legend__team' /> Team
        </span>
        <span>
          <i className='ln-legend__new' /> mit Lena
        </span>
      </span>
    </Section>
  )
}

export const UI = {
  message: Message,
  newJob: NewJob,
  choice: Choice,
  expert: Expert,
  profile: Profile,
  invite: Invite,
  challenge: Challenge,
  strength: Strength,
  table: Table,
  insights: Insights,
  hire: Hire,
  learn: Learn,
  radar: Radar
}
